import { useEffect } from 'react';
export var isInIframe = function isInIframe() {
  if (false) return false;

  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
/** Syncs the page height to the parent page in iframe-embed scenarios (message type keeps the jove-broker-portal prefix for compatibility with existing embedders) */

export var usePortalIframeHeightSync = function usePortalIframeHeightSync() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  /**
   * effects
   */
  useEffect(function () {
    if (!enabled || false || !isInIframe()) return;

    var postHeightCallback = function postHeightCallback() {
      var _window$parent;

      (_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage({
        type: 'jove-broker-portal:height',
        height: document.documentElement.scrollHeight
      }, '*');
    };

    postHeightCallback();
    var observer = new ResizeObserver(postHeightCallback);
    observer.observe(document.body);
    window.addEventListener('load', postHeightCallback);
    return function () {
      observer.disconnect();
      window.removeEventListener('load', postHeightCallback);
    };
  }, [enabled]);
};
/** In-iframe navigation: with breakout, escapes the iframe and opens in the top window */

export var redirectPortalUrl = function redirectPortalUrl(url) {
  var breakout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (false || !url) return;

  if (breakout && isInIframe()) {
    window.top.location.href = url;
    return;
  }

  window.location.href = url;
};